import { lazy } from "react";
import { Navigate, Route } from "react-router-dom";
import { PATHS } from "../../../constants/paths";

const AppConfigPage = lazy(() => import("../AppConfig"));
const DeploymentTypesPage = lazy(() => import("../tabs/DeploymentTypeTab"));
const ModuleUsagePage = lazy(() => import("../tabs/ModuleUsage"));
const CustomComponentsPage = lazy(() => import("../tabs/CustomComponentsTab"));
const DefaultCustomerInsightsConfigPage = lazy(
  () => import("../tabs/ConfigCustomerInsightsTab")
);

const useAppConfigRoutes = () => (
  <Route path={PATHS.AppConfig.Path} element={<AppConfigPage />}>
    <Route path="" element={<DeploymentTypesPage />} />
    <Route
      path={PATHS.AppConfig.Tabs.DeploymentTypes.Path}
      element={<DeploymentTypesPage />}
    />
    <Route
      path={PATHS.AppConfig.Tabs.ModuleUsage.Path}
      element={<ModuleUsagePage />}
    />
    <Route
      path={PATHS.AppConfig.Tabs.CustomComponents.Path}
      element={<CustomComponentsPage />}
    />
    <Route
      path={PATHS.AppConfig.Tabs.DefaultCustomerInsightsConfig.Path}
      element={<DefaultCustomerInsightsConfigPage />}
    />
    <Route
      index
      element={
        <Navigate replace to={PATHS.AppConfig.Tabs.DeploymentTypes.Path} />
      }
    />
  </Route>
);

export { useAppConfigRoutes };
